import React from 'react';
import { withRouter } from 'react-router-dom';
import { Alert, AlertTitle } from '@material-ui/lab';
import Typography from '@material-ui/core/Typography';
import { Link } from '@material-ui/core';
import Rollbar from 'rollbar';
import styles from './error-boundary.module.scss';

const rollbar = new Rollbar({
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV,
  /*
   * Don't send the values of inputs when sending
   * telemetry results related to an error.
   * */
  scrubTelemetryInputs: true,
  payload: {
    client: {
      javascript: {
        code_version: '3',
        source_map_enabled: true,
      },
    },
  },
});

class BaseErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any) {
    rollbar.error(error);
  }

  handleGoHome() {
    const { history } = this.props as any;
    history.replace('/');
    this.setState({ hasError: false }, () => {
      window.location.reload();
    });
  }

  render() {
    if ((this.state as any).hasError) {
      return (
        <div className={styles.container}>
          <Alert severity="error">
            <AlertTitle>Något gick fel.</AlertTitle>
            <Typography>
              Felinformation skickades till våra tjänster.
            </Typography>
            <Typography>
              Klicka{' '}
              <Link onClick={() => this.handleGoHome()} className={styles.link}>
                här
              </Link>{' '}
              för att ladda om sidan.
            </Typography>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withRouter(BaseErrorBoundary as any);
